<template>
  <div>
    <DeleteUserAccountDialog
      :deleteTitle="firstConfirmationTitle"
      :deleteMessage="firstConfirmationMsg"
      :hasPackage="hasPackage"
      ref="deleteUserAccount"
    />
    <q-chip
      icon-right="delete"
      style="cursor: pointer"
      text-color="white"
      clickable
      push
      :color="$q.dark.mode === true ? 'grey-7' : 'negative'"
      :label="
        profile.hasOwnProperty('del_request')
          ? 'Cancel Delete Request'
          : 'Delete Account'
      "
      @click="
        profile.hasOwnProperty('del_request')
          ? cancelDeleteRequest()
          : deleteAccount()
      "
      class="glossy text-capitalize text-white q-px-lg"
    />

    <DeleteConfirmation
      :deleteTitle="firstConfirmationTitle"
      :deleteMessage="firstConfirmationMsg"
      ref="firstConfirmation"
    />
    <DeleteConfirmation
      :deleteTitle="secondConfirmationTitle"
      :deleteMessage="secondConfirmationMsg"
      ref="secondConfirmation"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import DeleteUserAccountDialog from "src/components/settings/DeleteAccount/DeleteDialog/DeleteUserAccountDialog.vue";
import DeleteConfirmation from "src/components/settings/DeleteAccount/ConfirmationDialog/DeleteConfirmation";
import { useQuasar } from "quasar";
const deleteUserAccount = ref(null);
const firstConfirmation = ref(null);
const secondConfirmation = ref(null);
const $q = useQuasar();
const emit = defineEmits(["delete"]);
const props = defineProps({
  hasPackage: {
    type: Boolean,
  },
  profile: {
    type: Object,
  },
});
const firstConfirmationTitle = ref(
  " Are you sure you want to request to delete your Account?"
);
const firstConfirmationMsg = ref(
  "After 10 days, your account and all your information will be permanently deleted, and you won't be able to retrieve your information including saved charts and packages."
);
const secondConfirmationTitle = ref("Confirm Again !");
const secondConfirmationMsg = ref(
  "Are you sure you want to request to delete your Account?"
);

const deleteAccount = async () => {
  const answer = await deleteUserAccount.value.openDialog();
  let confirmation2 = false;
  const confirmation1 = await firstConfirmation.value.open();
  if (confirmation1) confirmation2 = await secondConfirmation.value.open();
  if (confirmation2) emit("deleteAccount", answer);
};

const cancelDeleteRequest = async () => {
  emit("undoDelete");
};
</script>
